"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "martello": {
    "ac30068b": [{
      "hkey": "32d5aa27",
      "slug": "martello",
      "name": "Martello",
      "primary": true,
      "skipSearch": false
    }],
    "montesole": [{
      "hkey": "32d5aa27",
      "slug": "martello",
      "name": "Martello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "594a85ff": [{
      "hkey": "32d5aa27",
      "slug": "martello",
      "name": "Martello",
      "primary": true,
      "skipSearch": false
    }],
    "val-d-enne": [{
      "hkey": "32d5aa27",
      "slug": "martello",
      "name": "Martello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;